/* eslint-disable react/forbid-prop-types */
/* eslint-disable-next-line max-len */
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Card, CardText, CardBody, Table } from 'reactstrap';
import PropTypes, { element, object } from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import Select from 'react-select';
import { setCurrencyFormat } from '../../../utils/helpers';
import { colorArrRedBlue, sortBySubscribersOptions } from '../helper';


const SubscribersTable = ({ dataToShowForDatesSelected, month,
  title, filterBasedOnFilter, categorisedBasedOn, firstColumn, currentlyShow, excelData, excelDataHeader }) => {
  const { t } = useTranslation('common');
  const categorisedBasedOnRef = useRef({ categorisedBasedOn });

  const [selectedOptions, setSelectedOptions] = useState([])
  const [sortBySelected, setSortBySelected] = useState(sortBySubscribersOptions[1])
  const allCategories = {}
  const currentDataByCategory = {};
  useEffect(() => {
    if (categorisedBasedOnRef?.current?.categorisedBasedOn !== categorisedBasedOn) {
      setSelectedOptions([])
    }
  }, [categorisedBasedOn])

  const changeFilter = (value) => {
    setSelectedOptions(value)
  };

  dataToShowForDatesSelected.forEach((item) => {
    if (item && currentDataByCategory[item?.[categorisedBasedOn]]) {
      currentDataByCategory[item?.[categorisedBasedOn]]?.push(item)
    } else if (item) {
      if (!item?.[categorisedBasedOn] || item?.[categorisedBasedOn] === 'null') {
        currentDataByCategory?.['N/A']?.push(item)
      } else {
        currentDataByCategory[item?.[categorisedBasedOn]] = [item]
      }
    }
  });
  const currentMonthCat = Object.keys(currentDataByCategory);
  let dataToPlot = [];
  const options = [];
  // const tableHaderData = [...new Set(currentDataByCategory.map(item => item.startDate))];

  const reduceCallback = (acc, day) => {
    // const date = moment(`${day.salesMonth}-${day?.salesYear}`, 'MMM-YYYY');
    // const MonthYear = date.format('MMM-YYYY');
    const curDate = day.startDate;
    if (acc[curDate]) {
      acc?.[curDate]?.push(day)
    } else {
      acc[curDate] = [day]
    }

    if (day && !allCategories[day?.[categorisedBasedOn]]) {
      if (!day?.[categorisedBasedOn] || day?.[categorisedBasedOn] === 'null') {
        allCategories['N/A'] = 'N/A';
      } else {
        allCategories[day?.[categorisedBasedOn]] = day?.[categorisedBasedOn]
      }
    }
    return acc
  }

  const handleDownload = () => {
    if (!excelData.length) return;

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Create headers array from tableHeaderData
    const headers = excelDataHeader?.map(col => col.Header) || [];

    // Create data array with only the fields specified in tableHeaderData
    const worksheetData = excelData?.map(row => {
      const filteredRow = {};
      excelDataHeader?.forEach(col => {
        filteredRow[col.Header] = row[col.accessor];
      });
      return filteredRow;
    }) || [];

    // Convert data to worksheet format with proper headers
    const ws = XLSX.utils.json_to_sheet(worksheetData, { header: headers });

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'report');

    // Write the file
    XLSX.writeFile(wb, 'Subscribers By Category/SKU.xlsx');
  };

  const getPercentage = (currValue, preValue) => {
    let v = 0;
    if (preValue > 0) {
      v = (((currValue - preValue) / preValue) * 100).toFixed(2) || '0';
      if (v === '0.00') {
        v = 0;
      }
    }
    else {
      v = 0;
    }
    return v;
  }

  const getColorCode = (salesPer) => {
    let colorCode;

    if (salesPer < 0) {
      const negValue = salesPer.split('-');
      if (negValue[1] < 10) {
        colorCode = colorArrRedBlue[0].toString();
      }
      else if (negValue[1] > 10 && negValue[1] < 20) {
        colorCode = colorArrRedBlue[1].toString();
      }
      else if (negValue[1] > 20 && negValue[1] < 30) {
        colorCode = colorArrRedBlue[2].toString();
      }
      else if (negValue[1] > 30 && negValue[1] < 40) {
        colorCode = colorArrRedBlue[3].toString();
      }
      else if (negValue[1] > 40 && negValue[1] < 50) {
        colorCode = colorArrRedBlue[4].toString();
      }
      else if (negValue[1] > 50 && negValue[1] < 60) {
        colorCode = colorArrRedBlue[5].toString();
      }
      else if (negValue[1] > 60 && negValue[1] < 70) {
        colorCode = colorArrRedBlue[6].toString();
      }
      else if (negValue[1] > 70 && negValue[1] < 80) {
        colorCode = colorArrRedBlue[7].toString();
      }
      else if (negValue[1] > 80 && negValue[1] < 90) {
        colorCode = colorArrRedBlue[8].toString();
      }
      else if (negValue[1] > 90) {
        colorCode = colorArrRedBlue[9].toString();
      }
    }
    else if (salesPer > 0) {
      if (salesPer < 10) {
        colorCode = colorArrRedBlue[10].toString();
      }
      else if (salesPer > 10 && salesPer < 20) {
        colorCode = colorArrRedBlue[11].toString();
      }
      else if (salesPer > 20 && salesPer < 30) {
        colorCode = colorArrRedBlue[12].toString();
      }
      else if (salesPer > 30 && salesPer < 40) {
        colorCode = colorArrRedBlue[13].toString();
      }
      else if (salesPer > 40 && salesPer < 50) {
        colorCode = colorArrRedBlue[14].toString();
      }
      else if (salesPer > 50 && salesPer < 60) {
        colorCode = colorArrRedBlue[15].toString();
      }
      else if (salesPer > 60 && salesPer < 70) {
        colorCode = colorArrRedBlue[16].toString();
      }
      else if (salesPer > 70 && salesPer < 80) {
        colorCode = colorArrRedBlue[17].toString();
      }
      else if (salesPer > 80 && salesPer < 90) {
        colorCode = colorArrRedBlue[18].toString();
      }
      else if (salesPer > 90) {
        colorCode = colorArrRedBlue[19].toString();
      }
    }
    else {
      colorCode = colorArrRedBlue[20].toString();
    }
    return colorCode;
  }
  let allDate = [];
  for (let i = 0; i < currentMonthCat.length; i += 1) {
    const cat = currentMonthCat[i];
    const currentMonth = currentDataByCategory?.[cat] ?? [];
    allDate = allDate?.concat(currentMonth);

    let currentDateMax = 0;
    currentMonth?.forEach((item) => {
      currentDateMax += Number(item.noOfSubscriptions)
    }
    );

    const currentYearMonthDayWise = currentMonth?.reduce(reduceCallback, {})
    const categoryWiseAmountTotal = Object.keys(currentYearMonthDayWise)?.sort((a, b) =>
      a?.toLowerCase() > b?.toLowerCase() ? 1 : -1).reduce((acc, date, index) => {
        const currentDateData = Object.keys(currentYearMonthDayWise)?.sort((a, b) =>
          a?.toLowerCase() > b?.toLowerCase() ? 1 : -1);

        const noOfSubscriptions = currentYearMonthDayWise[date]?.reduce((accum, item) =>
          Number(Number(Number(accum) + Number(item.noOfSubscriptions)).toFixed(2)), 0);
        const previousDate = currentDateData[index - 1];
        const preNoOfSubscriptions = currentYearMonthDayWise[previousDate]?.reduce((accPre, item) =>
          Number(Number(Number(accPre) + Number(item.noOfSubscriptions)).toFixed(2)), 0) ?? 0;

        const percentageNoofSubscribers = getPercentage(noOfSubscriptions, preNoOfSubscriptions) ?? 0;
        const cardColorCode = getColorCode(percentageNoofSubscribers);

        acc[date] = {
          totalSubscriptionsPerDate: noOfSubscriptions,
          // OrderCount: orderCount, 
          subscribersPercentage: percentageNoofSubscribers,
          ColorCode: cardColorCode
        };
        return acc
      }, {})

    options.push({
      value: cat, label: cat
    })

    dataToPlot.push({
      title: cat,
      categoryWiseAmountTotal,
      currentDateMax: currentDateMax > 0 ? currentDateMax : 0
    })


  }
  const tableHaderData = [...new Set(allDate.map(item => item.startDate))]

  if (selectedOptions?.length) {
    const selected = selectedOptions?.reduce((acc, item) => {
      acc[item?.value] = item.value
      return acc
    }, {})
    dataToPlot = dataToPlot.filter(item => selected[item.title])
  }

  const sortBy = sortBySelected?.value;


  if (sortBy === 'title') {
    dataToPlot = dataToPlot?.sort((a, b) =>
      a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
  } else {
    dataToPlot = dataToPlot?.sort((a, b) =>
      a?.[sortBy] < b?.[sortBy] ? 1 : -1)
  }
  return (
    <Col xs="12">
      <Card className="pb-3 show-categ-daily-sales">
        <CardBody>
          <div className="card__title row align-items-center">
            <h5 className="bold-text col-md-4">{title}</h5>
            <div className="form__form-group mb-0 col-md-8">
              <div className="row justify-content-center align-items-center">
                <div className="col-5" id='dvTable'>
                  <span className="form__form-group-label font-weight-bold">
                    {`Select ${currentlyShow?.value}`}</span>
                  <div className="form__form-group-field" >
                    <Select
                      value={selectedOptions}
                      options={options}
                      clearable={false}
                      placeholder={`Select ${currentlyShow?.value}`}
                      className="select_filter"
                      onChange={changeFilter}
                      classNamePrefix="react-select"
                      isMulti
                    />
                  </div>
                </div>
                <div className="col-4" id='dvChartFilter'>
                  <span className="form__form-group-label font-weight-bold">Sort By</span>
                  <div className="form__form-group-field">
                    <Select
                      value={sortBySelected}
                      options={sortBySubscribersOptions}
                      clearable={false}
                      placeholder="Sort By"
                      className="select_filter-180"
                      onChange={setSortBySelected}
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                <div className="col-2" id='dvChartView'>
                  <div className="ExcelTable">
                    <div
                      disabled={!excelData.length}
                      className="btn btn-primary btn-sm download"
                      onClick={handleDownload}
                    >
                      Download
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Table responsive striped className="dashboard__table-orders" width="100%">
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', minWidth: '150px' }}>{firstColumn}</th>
                  {tableHaderData?.sort((a, b) =>
                    a?.toLowerCase() > b?.toLowerCase() ? 1 : -1).map((item, index) => (
                      <th style={{ textAlign: 'center' }}>{item}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {dataToPlot?.length ? dataToPlot?.map(dataValue => (
                  <tr>
                    <td style={{
                      paddingTop: '2px', paddingBottom: '2px',
                      minWidth: '150px'
                    }}>{dataValue.title}
                    </td>
                    {tableHaderData.map((item, index) => (
                      <td style={{
                        paddingTop: '2px', paddingBottom: '2px', paddingLeft: '3px',
                        paddingRight: '3px', marginLeft: '0px',
                        marginRight: '0px'
                      }}>
                        <Card body style={{
                          background: dataValue?.categoryWiseAmountTotal?.
                          [item]?.totalSubscriptionsPerDate > 0
                            ? dataValue?.categoryWiseAmountTotal?.[item]?.ColorCode : colorArrRedBlue[20],
                          width: '100px',
                          height: '50px', marginBottom: '0px',
                          marginTop: '0px', paddingTop: '3px', paddingBottom: '3px',
                          paddingRight: '6px'
                        }}>
                          <CardText style={{
                            color: '#000000', fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                            paddingTop: '0px', marginBottom: '0px'
                          }}>
                            {setCurrencyFormat(dataValue?.categoryWiseAmountTotal?.[item]?.
                              totalSubscriptionsPerDate, false)}
                          </CardText>
                          {dataValue?.categoryWiseAmountTotal?.[item]?.subscribersPercentage < 0 && (
                            <CardText style={{
                              color: '#000000', fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                              paddingTop: '0px', marginBottom: '0px', marginRight: '0px'
                            }}>
                              <span>
                                <svg width="18" height="18" fill="currentColor" viewBox="0 0 30 30">
                                  <path
                                    d="M16,18L18.29,15.71L13.41,10.83L9.41,14.83L2,7.41L3.41,
                                         6L9.41,12L13.41,8L19.71,14.29L22,12V18H16Z"
                                  />
                                </svg>
                                {dataValue?.categoryWiseAmountTotal?.[item]?.subscribersPercentage}%
                              </span>
                            </CardText>
                          )}
                          {dataValue?.categoryWiseAmountTotal?.[item]?.subscribersPercentage > 0 && (
                            <CardText style={{
                              color: '#000000', fontSize: '11px',
                              textAlign: 'right', paddingBottom: '15px',
                              paddingTop: '0px', marginBottom: '15px'
                            }}>
                              <span>
                                <svg width="18" height="18" fill="currentColor" viewBox="0 0 30 30"
                                  marginBottom="50px">
                                  <path
                                    d="M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,
                                                  12L13.41,16L19.71,9.71L22,12V6H16Z"
                                  />
                                </svg>
                                {dataValue?.categoryWiseAmountTotal?.[item]?.subscribersPercentage}%
                              </span>
                            </CardText>
                          )}
                          {dataValue?.categoryWiseAmountTotal?.[item]?.
                            subscribersPercentage === 0 &&
                            dataValue?.categoryWiseAmountTotal?.[item]?.
                              subscribersPercentage === 0.00 && (
                              <CardText style={{
                                color: '#000000', fontSize: '11px',
                                textAlign: 'right', paddingBottom: '0px',
                                paddingTop: '0px', marginBottom: '0px'
                              }}>
                                <span>

                                  {dataValue?.categoryWiseAmountTotal?.[item]?.subscribersPercentage}%
                                </span>
                              </CardText>
                            )}
                        </Card>
                      </td>
                    ))}
                  </tr>
                )) : 'No data to display'}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

SubscribersTable.propTypes = {
  dataToShowForDatesSelected: PropTypes.array.isRequired,
  firstColumn: PropTypes.string,
  month: PropTypes.object.isRequired,
  title: PropTypes.string,
  filterBasedOnFilter: PropTypes.func.isRequired,
  categorisedBasedOn: PropTypes.string,
  currentlyShow: PropTypes.object.isRequired,
  excelData: PropTypes.array.isRequired,
  excelDataHeader: PropTypes.array.isRequired,
};

SubscribersTable.defaultProps = {
  title: 'Category Sales By Month',
  firstColumn: 'Product Category',
  categorisedBasedOn: 'productCategory',
}

export default SubscribersTable;